<template>
  <!-- todo take conditional event wrapper off  -->
  <automation-card
    v-if="openWindow === 'automation'"
    :event="event"
    @close="close"
  />
  <add-location-card
    v-if="openWindow === 'add-location'"
    :event="event"
    @close="close"
  />
  <remove-location-card
    v-if="openWindow === 'remove-location'"
    :event="event"
    :location="event.locations[locationRemoveIndex]"
    @close="close"
  />
  <add-contact-card
    v-if="openWindow === 'add-contact'"
    :event="event"
    @close="close"
  />
  <remove-contact-card
    v-if="openWindow === 'remove-contact'"
    :event="event"
    :contact="event.contacts[contactRemoveIndex]"
    @close="close"
  />
  <add-note-card
    v-if="openWindow === 'add-note'"
    :event="event"
    @close="close"
  />
  <edit-event-card v-if="openWindow === 'edit'" :event="event" @close="close" />
  <delete-event-card
    v-if="openWindow === 'delete'"
    :event="event"
    @close="close"
  />
  <payment-card v-if="openWindow === 'payment'" :event="event" @close="close" />
  <forms v-if="openWindow === 'forms'" :event="event" @close="close" />
  <contracts v-if="openWindow === 'contract'" :event="event" @close="close" />
  <invoice v-if="openWindow === 'invoice'" :event="event" @close="close" />
  <add-to-do-modal
    :event="event"
    v-if="openWindow === 'add-to-do'"
    @close="close"
  />
  <div id="spin-event-page-wrapper">
    <div id="event-page-heading">
      <heading :heading="heading" :subheading="subheading" />
      <icon-bar
        id="event-page-icon-bar"
        :icons="icons"
        @icon-clicked="iconClicked"
      />
    </div>
    <div id="event-page-alert-scroller">
      <alert-card
        v-for="alert in alertCards"
        :key="alert"
        :display="alert.display"
        :button-text="alert.buttonText"
        :primaryHeading="alert.primaryHeading"
        :middleHeading="alert.middleHeading"
        :lowerHeading="alert.lowerHeading"
        :icon="alert.icon"
        @action-taken="alert.method()"
      />
    </div>
    <div id="event-page-components">
      <location-gallery
        id="scs-event-page-location-gallery"
        heading="Where"
        :icons="tenant ? ['plus'] : []"
        :locations="locations"
        :fetched="locationsFetched"
        @icon-clicked="iconClicked('add-location')"
        @remove-location="removeLocation"
      />
      <contact-list
        id="scs-event-page-contact-list"
        heading="Who"
        :icons="tenant ? ['plus'] : []"
        :contacts="contacts"
        :navigable="tenant"
        :fetched="contactsFetched"
        @icon-clicked="iconClicked('add-contact')"
        @remove-contact="removeContact"
      />
      <notes
        id="scs-event-page-notes"
        heading="Notes"
        :icons="['plus']"
        :event="event"
        @open-add-note="iconClicked('add-note')"
      />
      <to-do-list
        id="scs-event-page-to-do-list"
        heading="To-Do"
        :icons="['plus']"
        :toDos="toDos"
        :fetched="toDosFetched"
        @icon-clicked="iconClicked('add-to-do')"
      />

      <!-- todo : add event activity component at bottom and create activity hooks -->
    </div>
  </div>
</template>

<script>
import Heading from "../Components/UI/Heading.vue";
import IconBar from "../Components/UI/IconBar.vue";
import AlertCard from "../Components/UI/AlertCard.vue";
import LocationGallery from "../Components/Events/LocationGallery.vue";
import ContactList from "../Components/Events/ContactList.vue";
import Notes from "../Components/Notes.vue";
import ToDoList from "../Components/ToDo/ToDoList.vue";
import Forms from "../Components/Events/Forms.vue";
import Contracts from "../Components/Events/Contracts.vue";
import Invoice from "../Components/Events/Invoice.vue";
import AddLocationCard from "../Components/UI/FloatingCards/Event/AddLocationCard.vue";
import RemoveLocationCard from "../Components/UI/FloatingCards/Event/RemoveLocationCard.vue";
import AddContactCard from "../Components/UI/FloatingCards/Event/AddContactCard.vue";
import RemoveContactCard from "../Components/UI/FloatingCards/Event/RemoveContactCard.vue";
import AutomationCard from "../Components/UI/FloatingCards/Event/AutomationCard.vue";
import PaymentCard from "../Components/UI/FloatingCards/Event/Payment/EventMakePayment.vue";
import EditEventCard from "../Components/UI/FloatingCards/Event/EditEventCard.vue";
import DeleteEventCard from "../Components/UI/FloatingCards/Event/DeleteEvent.vue";
import AddNoteCard from "../Components/UI/FloatingCards/Event/AddNoteCard.vue";
import AddToDoModal from "../Components/ToDo/AddToDoModal.vue";
import {
  formatDate,
  formatTime,
  total,
  balanceOutstanding,
  formatPrice,
} from "../Helpers/invoice.js";

export default {
  data() {
    return {
      openWindow: null,
      locationRemoveIndex: undefined,
      contactRemoveIndex: undefined,
      contact: {},
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    event() {
      return this.$store.getters.event;
    },
    tenant() {
      if (this.$store.state.user) {
        return (
          this.$store.state.user.tenantId === this.$store.state.user.userId
        );
      } else {
        return false;
      }
    },
    icons() {
      let icons = ["contract", "forms", "invoice", "credit-card"];
      if (this.tenant) {
        icons.push("automation", "edit", "trash-can");
      }
      return icons;
    },
    eventDate() {
      if (this.event) {
        switch (this.event.api_version) {
          case "9-28-2022":
            return this.event.date;

          default:
            return this.event.data.date;
        }
      } else {
        return undefined;
      }
    },
    heading() {
      return this.event ? this.event.title : "...";
    },
    subheading() {
      let eventTimes = (event) => {
        switch (event.api_version) {
          case "9-28-2022":
            return `${formatTime(
              event.start_time,
              event.time_zone ? event.time_zone.Name : ""
            )} - ${formatTime(
              event.end_time,
              event.time_zone ? event.time_zone.Name : ""
            )}`;

          default:
            return `${formatTime(
              event.data.startTime,
              event.time_zone ? event.time_zone.Name : ""
            )} - ${formatTime(
              event.data.endTime,
              event.time_zone ? event.time_zone.Name : ""
            )}`;
        }
      };
      return this.event
        ? `${formatDate(
            this.eventDate,
            this.event.time_zone ? this.event.time_zone.Name : undefined
          )}, ${eventTimes(this.event)}`
        : "...";
    },
    retainerAmount() {
      let depositType = this.$store.getters.depositType;
      let depositAmount = this.$store.getters.depositAmount * 100;
      switch (depositType) {
        case "percentage":
          return total(this.event) * depositAmount;
        default:
          return depositAmount;
      }
    },
    alertCards() {
      let array = [];
      if (this.event) {
        let retainerTerminology = this.$store.getters.depositTerminology;
        let iconClicked = (param) => this.iconClicked(param);
        let retainerCard = {
          display: "button-with-icon",
          root: this,
          primaryHeading: `${formatPrice(
            this.retainerAmount
          )} ${retainerTerminology} due`,
          buttonText: `Pay ${retainerTerminology}`,
          icon: "invoice",
          method() {
            iconClicked("credit-card");
          },
        };
        let contractsCard = () => {
          let unsignedContracts = () => {
            if (this.event) {
              return this.event.contracts.filter((x) => {
                return !x.signerDate;
              });
            } else {
              return [];
            }
          };
          if (unsignedContracts().length > 0) {
            return {
              display: "button-with-icon",
              primaryHeading: `${
                unsignedContracts().length
              } contract(s) unsigned`,
              buttonText: "Sign contracts",
              icon: "contract",
              method() {
                iconClicked("contract");
              },
            };
          } else {
            return null;
          }
        };
        let daysLeftCard = () => {
          let difference = new Date(this.eventDate) - new Date();
          let daysLeft = Math.ceil(difference / 1000 / 60 / 60 / 24);
          let exclamation = () => {
            if (daysLeft > 365) {
              return "a ways to go!";
            }
            if (daysLeft < 365 && daysLeft > 182) {
              return "getting there!";
            }
            if (daysLeft < 182 && daysLeft > 90) {
              return "get excited!";
            } else {
              return "so close!";
            }
          };
          return {
            display: "three-line-heading",
            primaryHeading: "Days left",
            middleHeading: daysLeft,
            lowerHeading: exclamation(),
          };
        };
        let formsReminder = () => {
          return {
            display: "button-with-icon",
            primaryHeading: `Complete forms`,
            buttonText: "Go to forms",
            icon: "forms",
            method() {
              iconClicked("forms");
            },
          };
        };
        if (
          total(this.event) - balanceOutstanding(this.event) <
          this.retainerAmount
        ) {
          array.push(retainerCard);
        }
        array.push(contractsCard(), formsReminder(), daysLeftCard());
      }
      return array.filter((x) => {
        return x;
      });
    },
    locations() {
      if (this.event) {
        return this.event.locations;
      } else {
        return [];
      }
    },
    contacts() {
      if (this.event) {
        return this.event.contacts;
      } else {
        return [];
      }
    },
    toDos() {
      if (this.event) {
        return this.event.toDos;
      } else {
        return [];
      }
    },
    toDosFetched() {
      if (this.event) {
        return this.event.toDosFetched;
      } else {
        return false;
      }
    },
    locationsFetched() {
      if (this.event) {
        return this.event.locationsFetched;
      } else {
        return false;
      }
    },
    contactsFetched() {
      if (this.event) {
        return this.event.contactsFetched;
      } else {
        return false;
      }
    },
  },
  methods: {
    iconClicked(icon) {
      switch (icon) {
        case "automation":
          this.openWindow = "automation";
          break;
        case "contract":
          this.openWindow = "contract";
          break;
        case "forms":
          this.openWindow = "forms";
          break;
        case "invoice":
          this.openWindow = "invoice";
          break;
        case "credit-card":
          this.openWindow = "payment";
          break;
        case "edit":
          this.openWindow = "edit";
          break;
        case "add-location":
          this.openWindow = "add-location";
          break;
        case "add-to-do":
          this.openWindow = "add-to-do";
          break;
        case "trash-can":
          this.openWindow = "delete";
          break;
        case "remove-location":
          this.openWindow = "remove-location";
          break;
        case "add-contact":
          this.openWindow = "add-contact";
          break;
        case "remove-contact":
          this.openWindow = "remove-contact";
          break;
        case "add-note":
          this.openWindow = "add-note";
          break;
        default:
          break;
      }
    },
    removeLocation(index) {
      this.locationRemoveIndex = index;
      this.iconClicked("remove-location");
    },
    removeContact(index) {
      this.contactRemoveIndex = index;
      this.iconClicked("remove-contact");
    },
    close() {
      this.openWindow = null;
    },
    // async establishData() {
    //   await this.setEvent();
    //   await this.$store.dispatch("setBusinessSettings", this.event.tenantId);
    // },
  },
  watch: {
    user(_newValue, oldValue) {
      if (oldValue === undefined) {
        this.establishData();
      }
    },
  },
  unmounted() {
    this.$store.commit("clearEvent");
  },
  created() {
    this.$store.state.event = this.$store.getters.events().find((x) => {
      console.log(this.$route.params.eventId);
      return x.userId === this.$route.params.eventId;
    });
    // this.establishData();
  },
  components: {
    RemoveContactCard,
    AddContactCard,
    Heading,
    IconBar,
    AlertCard,
    LocationGallery,
    ContactList,
    Notes,
    Forms,
    Contracts,
    RemoveLocationCard,
    Invoice,
    ToDoList,
    AutomationCard,
    PaymentCard,
    AddLocationCard,
    EditEventCard,
    DeleteEventCard,
    AddNoteCard,
    AddToDoModal,
  },
};
</script>
<style scoped>
@media screen {
  #spin-event-page-wrapper {
    width: 100%;
  }

  #event-page-heading {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  #event-page-icon-bar {
    margin: 35px 0;
  }
  #event-page-alert-scroller {
    display: flex;
    width: 100%;
    overflow: scroll;
    padding: 20px;
  }

  #event-page-components {
    display: flex;
    flex-wrap: wrap;
  }

  #scs-event-page-location-gallery {
    width: 500px;
    min-height: 200px;
    max-height: 400px;
  }

  #scs-event-page-contact-list {
    width: 400px;
    min-height: 200px;
    max-height: 400px;
  }

  #scs-event-page-notes {
    width: 600px;
    min-height: 200px;
    max-height: 500px;
  }

  #scs-event-page-to-do-list {
    width: 400px;
    min-height: 200px;
    max-height: 500px;
  }
  @media (min-width: 800px) {
    #spin-event-page-wrapper {
      width: 100%;
      padding: 50px;
      box-sizing: border-box;
    }

    #event-page-heading {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    #event-page-icon-bar {
      margin: 0;
    }

    #event-page-alert-scroller {
      display: flex;
      width: 100%;
      overflow: scroll;
      padding: 20px;
    }

    #event-page-components {
      display: flex;
      flex-wrap: wrap;
    }

    #scs-event-page-location-gallery {
      width: 500px;
      min-height: 200px;
      max-height: 400px;
    }

    #scs-event-page-contact-list {
      width: 400px;
      min-height: 200px;
      max-height: 400px;
    }

    #scs-event-page-notes {
      width: 600px;
      min-height: 200px;
      max-height: 500px;
    }

    #scs-event-page-to-do-list {
      width: 400px;
      min-height: 200px;
      max-height: 500px;
    }
  }
}

@media print {
  #spin-event-page-wrapper {
    display: none;
  }
}
</style>
